<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2022-10-12 18:00:54
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-10 17:45:03
 * @FilePath: \seller.sviptrader.com\src\components\business\applySampleDrawer\components\confirmCooGoods\components\goodsBox.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="flex flex-align-center">
		<div class="pic mt-2">
			<el-avatar shape="square" :size="52" :src="row.product_pic"></el-avatar>
		</div>
		<div class="details font-h6-regular ml-8">
			<div class="flex flex-align-center">
				<platform-icon :platformId="platformId"></platform-icon>
				<el-tooltip placement="top" :content="row.product_name" v-ak-tooltip-auto-show>
					<p class="yx-color-pure-1 line-ellipsis-1 ml-6" style="max-width: 180px">{{ row.product_name }}</p>
				</el-tooltip>
			</div>
			<p class="yx-color-text-p-4 mt-2">商品ID：{{ row.third_product_id }}</p>
			<div class="shop-tag font-h6-regular yx-color-text-p-4 mt-4 align-center">
				<i class="i-shop mr-4"></i>
				<el-tooltip class="item" effect="dark" :content="row.shop_name" :disabled="isTipShopName" placement="top">
					<span>{{ row.shop_name | textFormat(6) }}</span>
				</el-tooltip>
			</div>
		</div>
	</div>
</template>
<script>
import { PLATFORM_DY } from '@/utils/dataMap';
export default {
	components: {},
	props: {
		row: {
			type: Object,
			default: () => {},
		},
		platformId: {
			type: [Number, String],
			default: PLATFORM_DY.value,
		},
	},
	data() {
		return {};
	},
	computed: {
		isTipShopName({ row }) {
			let name = row.shop_name;
			return name && name.length > 6 ? false : true;
		},
	},
};
</script>
<style lang="less" scoped>
.shop-tag {
	height: 18px;
	line-height: 18px;
	border-radius: 2px;
	background-color: #f7f8fa;
	display: inline-block;
	padding: 0px 3px;
}
</style>
